// extracted by mini-css-extract-plugin
export default {"image":"HelloImage_image__7AsYL"};